

/* ========================================================================
 * Transition
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('k-carousel')

    var transEndEventNames = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);


/* ========================================================================
 * Carousel
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element = $(element)
    this.$indicators = this.$element.find('.k-carousel-indicators')
    this.options = options
    this.paused = null
    this.sliding = null
    this.interval = null
    this.$active = null
    this.$items = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 2000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      case 13: e.target.click(); break
      case 32: e.target.click(); break
      //case 9: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
      || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding) return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding || $(this.$element).find(document.activeElement).length) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding || $(this.$element).find(document.activeElement).length) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active = this.$element.find('.item.active')
    var $next = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
      this.$element.clone().appendTo(this.$element.parent())
    }
/*
    var item = $('.k-carousel-indicators').find('li')

    $(item).removeClass('lr-border');
    for (var i = 0; i < item.length; i++) {
      var currentItem = $('.k-carousel-indicators').find('li').eq(i);
      if ($(currentItem).hasClass('active') && i == 0) {
        $('.k-carousel-indicators').find('li').eq(1).addClass('lr-border');
      } else {
        $('.k-carousel-indicators').find('li').eq(0).addClass('lr-border');
      }
    }
*/
    isCycling && this.cycle()

    window.awardSliderFocus && $next.focus()

    //console.log('end of slide',$(this.$element).find(document.activeElement).length,window.awardSliderFocus,document.activeElement)//document.activeElement


    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('k-carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }
    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  var awardsLoading = debounce(function () {

    var scroll = Math.round($(window).scrollTop());
    var awadrsEle = $('body').find('.ac-slider.k-carousel');
    var awadrsTopPos = Math.round($(awadrsEle).offset().top);
    var awadrsEleHeight = Math.round($(awadrsEle).height());

    scroll = scroll + 400;
    if (scroll >= awadrsTopPos) {
      if ($(window).width() > 767) {
        $('[data-ride="k-carousel"]').each(function () {
          var $carousel = $(this)
          $('.ac-slider .overview .item').each(function () {
            var imgSrc = $(this).data('desktop-img');
            $(this).css('background-image', 'url("' + imgSrc + '")');
          });
          $('.ac-slider .k-carousel-indicators li').each(function () {
            var imgSrc = $(this).data('desktop-img');
            $(this).css('background-image', 'url("' + imgSrc + '")');
          });
          Plugin.call($carousel, $carousel.data())
          window.removeEventListener('scroll', awardsLoading);
        })
      } else {
        $('.ac-slider .overview .item').each(function () {
          var imgSrc = $(this).data('mobile-img');
          $(this).css('background-image', 'url("' + imgSrc + '")');
        });
      }
    }
  }, 0);

  if ($('.ac-slider.k-carousel').length > 0) {
    window.addEventListener('scroll', awardsLoading);
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

}(jQuery);


$('document').ready(function () {
  awardSlider();
  $('.awards-container .k-carousel-inner li').attr('tabindex',-1)// overrides to HTML
  $(window).on('resize', function () {
    awardSlider();
  });
  function awardSlider() {
    $('.ac-slider .overview .item .content').each(function () {
      if ($(this).find('.product-cta').html() !== '') {
        $(this).find('.product-cta').removeClass('hide');
      } else {
        $(this).find('.product-cta').addClass('hide');
      }
      if ($(this).find('.a11y-tooltip span').html() !== '') {
        $(this).find('.a11y-tooltip a').removeClass('hide');
      } else {
        $(this).find('.a11y-tooltip a').addClass('hide');
      }
    });
    if ($(window).width() > 767) {

      var $viewportIndicators = $('.k-carousel').find(".k-carousel-indicators:first");
      var $viewportIndicatorsItem = $viewportIndicators.find("li");
      var $viewportOverview = $('.k-carousel').find(".k-carousel-inner:first");
      var $viewportOverviewItem = $viewportOverview.find("li");
      $('.k-carousel-indicators li:eq(0)').addClass('active');
      $('.k-carousel-inner li:eq(0)').addClass('active');
      $('.k-carousel-indicators li:eq(1)').addClass('lr-border');
      for (var i = 0; i < $viewportIndicatorsItem.length; i++) {
        $viewportIndicatorsItem.eq(i).attr('data-slide-to', i);
      }

      // $('.ac-slider .overview .item').each(function () {
      //   var imgSrc = $(this).data('desktop-img');
      //   $(this).css('background-image', 'url("' + imgSrc + '")');
      // });
      // $('.ac-slider .k-carousel-indicators li').each(function () {
      //   var imgSrc = $(this).data('desktop-img');
      //   $(this).css('background-image', 'url("' + imgSrc + '")');
      // });


      $viewportOverviewItem.on('blur', function () {
        window.awardSliderFocus = false;
        //console.log('awardSliderFocus = false')
      });
      $viewportIndicatorsItem.on('focus', function () {
        window.awardSliderFocus = true;
        //console.log('awardSliderFocus = true')
      })
      $viewportIndicatorsItem.on('click', function () {
        $(this).parent().parent().find('.overview li').removeClass('itemHover');
      }).on('mouseover', function () {
        $(this).parent().parent().find('.overview li').removeClass('itemHover');
        $(this).parent().parent().find('.overview li.active').addClass('itemHover');
      }).on('mouseleave', function () {
        $(this).parent().parent().find('.overview li').removeClass('itemHover');
      });
      $('.viewport').removeClass('swiper-container swiper-container-horizontal swiper-container-android');
      $('.ac-slider .swiper-wrapper').css({ 'transform': 'none' });

    } else {
      // $('.ac-slider .overview .item').each(function () {
      //   var imgSrc = $(this).data('mobile-img');
      //   $(this).css('background-image', 'url("' + imgSrc + '")');
      // });
      $('.viewport').addClass('swiper-container');
      var swiper = new Swiper('.viewport.swiper-container', {
        navigation: {
          nextEl: ".ac-slider-m-next",
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide'
        },
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: false,
        autoplayDisableOnInteraction: false,
      });
      $(document).on('click', '.ac-slider-m-next', function () {
        addArrowColor(this);
      });
      addArrowColor($('.ac-slider-m-next'));
    }
  }
  function addArrowColor(arrow) {
    var ssa = $('.ac-slider .overview').find('.swiper-slide-active');

    $(arrow).removeClass('ac-slider-m-next-00');
    if (ssa.hasClass('color_00')) {
      $(arrow).addClass('ac-slider-m-next-00');
    }
  }
});

  // TEMP CODE TO BE DELETED AFTER TESTING
  //document.addEventListener('keyup',function(){console.log('active element',document.activeElement.getAttribute('id') || document.activeElement.getAttribute('aria-label') || document.activeElement.getAttribute('href') || 'something')})
  /*
  $('.k-carousel-indicators li').each(function(i,x){
		$(x).attr({'aria-label':'this is slide '+(i+1),'aria-expanded':false})
		console.log(x)
	})
	
	$('.k-carousel-inner li').each(function(i,x){
		$(x).removeAttr('aria-label').removeAttr('aria-expanded').removeAttr('role')
		$(x).attr('tabindex',-1)
		$(x).prepend( '<span class="a11y-hidden" role="tab" aria-expanded="true" aria-label="this is label '+ i +'"></span>' );
		console.log(x)
	})
*/